import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useParameterStore } from '../store/ParameterStore';
import { ParameterType } from '@/types/parameterTypes';
import { useStepHasDisabledStatus } from './useStepHasDisabledStatus';
import { I18n } from '@/i18n/I18n';

export const useStepIsDisabled = (stepId: string): { disabled: boolean, disableMessage?: string } => {
  const stepInputParameters = useParameterStore(useShallow(state => state.parametersForSubjectAndType(stepId, ParameterType.INPUT)));
  const validationsPassing = useParameterStore(useShallow(state => state.parameterValidationsPassing(stepInputParameters.map(parameter => parameter.id))));
  const hasEmptyInputParameters = stepInputParameters.some(parameter => parameter.hasEmptyField());

  const stepIsDisabled = useStepHasDisabledStatus(stepId);

  const disabled = useMemo(() => {
    return !validationsPassing
    || stepIsDisabled
    || hasEmptyInputParameters;
  }, [validationsPassing, stepIsDisabled, hasEmptyInputParameters]);

  let disableMessage = '';
  if (hasEmptyInputParameters) {
    const missingInputParameters = stepInputParameters.filter(parameter => parameter.hasEmptyField());
    disableMessage = I18n.get('stepInputParametersMissing', { parameterTitles: missingInputParameters.map(parameter => parameter.title).join(', ') });
  }

  return { disabled, disableMessage };
};
